import GLightbox from "glightbox";

// var lightboxInlineIframe = GLightbox({
//     selector: ".glightbox",
// });

window.GLightbox = GLightbox;

document.addEventListener("DOMContentLoaded", function () {
    let lightboxElements = document.querySelectorAll('.glightbox');

    lightboxElements.forEach(element => {
        let lightbox = GLightbox({
            selector: "#" + element.getAttribute('id'),
        });

        lightbox.on("open", (e) => {
            lightbox.modal.querySelectorAll("source[data-src]").forEach(function(item) {
                if(item.getAttribute('src') == null) {
                    item.setAttribute("src", item.getAttribute('data-src'));
                    item.parentElement.load();
                }
            });
        });

        lightbox.once('slide_changed', () => {
            // Do something just one time
        });
    });
});